// Static demo-mode fill-in data for Notifications.component.jsx.
// Shape must match exactly what fetchUserNotifications normally resolves to
// and what the component reads off each row: `notificationType` (one of
// notificationTypes.*), `exportStatus` (one of notificationStatuses.*),
// `exportUrl` (only rendered as a download link when exportStatus is
// COMPLETED), and `createdAt` — a Firestore Timestamp-like object read via
// `.toDate()` both for sorting (NotificationsComponent's initial sort) and
// for display (formatTimeFromFirestoreTimestamp in @/utils/timeUtils).

import {
  notificationStatuses,
  notificationTypes,
} from './Notifications.constants';

// Mimics a Firestore Timestamp closely enough for this view's `.toDate()`
// call sites — takes an ISO string and returns a Date on demand.
const toFirestoreTimestamp = (isoString) => ({
  toDate: () => new Date(isoString),
});

// Anchored to "today" so the export history never goes stale — a hardcoded
// past date would drift further behind every day the demo stays live (see
// UserAttendance.demoData.js for the same pattern). The one PENDING export
// is kept a few minutes old so it still reads as "still processing" rather
// than stuck for months.
const DAY_MS = 24 * 60 * 60 * 1000;
const MIN_MS = 60 * 1000;
const daysAgoAt = (daysAgo, hh, mm) => {
  const d = new Date(Date.now() - daysAgo * DAY_MS);
  d.setUTCHours(hh, mm, 0, 0);
  return d.toISOString();
};
const minutesAgo = (n) => new Date(Date.now() - n * MIN_MS).toISOString();

export const DEMO_NOTIFICATIONS = [
  {
    id: 'demo-notification-1',
    notificationType: notificationTypes.TIMELINE_EXPORT,
    exportStatus: notificationStatuses.COMPLETED,
    exportUrl: 'https://example.com/exports/demo-timeline-export-1.csv',
    createdAt: toFirestoreTimestamp(daysAgoAt(0, 8, 45)),
  },
  {
    id: 'demo-notification-2',
    notificationType: notificationTypes.USER_ATTENDANCE_EXPORT,
    exportStatus: notificationStatuses.COMPLETED,
    exportUrl: 'https://example.com/exports/demo-attendance-export-1.csv',
    createdAt: toFirestoreTimestamp(daysAgoAt(1, 17, 20)),
  },
  {
    id: 'demo-notification-3',
    notificationType: notificationTypes.TIMELINE_EXPORT,
    exportStatus: notificationStatuses.PENDING,
    exportUrl: null,
    createdAt: toFirestoreTimestamp(minutesAgo(8)),
  },
  {
    id: 'demo-notification-4',
    notificationType: notificationTypes.USER_ATTENDANCE_EXPORT,
    exportStatus: notificationStatuses.FAILED,
    exportUrl: null,
    createdAt: toFirestoreTimestamp(daysAgoAt(2, 15, 30)),
  },
  {
    id: 'demo-notification-5',
    notificationType: notificationTypes.TIMELINE_EXPORT,
    exportStatus: notificationStatuses.COMPLETED,
    exportUrl: 'https://example.com/exports/demo-timeline-export-2.csv',
    createdAt: toFirestoreTimestamp(daysAgoAt(3, 9, 12)),
  },
  {
    id: 'demo-notification-6',
    notificationType: notificationTypes.USER_ATTENDANCE_EXPORT,
    exportStatus: notificationStatuses.COMPLETED,
    exportUrl: 'https://example.com/exports/demo-attendance-export-2.csv',
    createdAt: toFirestoreTimestamp(daysAgoAt(4, 13, 50)),
  },
  {
    id: 'demo-notification-7',
    notificationType: notificationTypes.TIMELINE_EXPORT,
    exportStatus: notificationStatuses.FAILED,
    exportUrl: null,
    createdAt: toFirestoreTimestamp(daysAgoAt(5, 18, 40)),
  },
];
